// extracted by mini-css-extract-plugin
module.exports = {"profileWrapper":"flavours-odl-profileWrapper-46704645"};